import { takeEvery, fork, put, all, call } from 'redux-saga/effects';
import { LOGIN_USER, LOGOUT_USER } from './actionTypes';
import { loginSuccess, logoutUserSuccess, apiError } from './actions';
import { satelliteLogin, satelliteLogout, satelliteMemberProfile } from '../../../helpers/fakebackend_helper';
import { BACKEND_URL } from "../../../services/backendURL";
import axios from 'axios';
import {
	setPermissions
} from "../../permission/actions";
import {
    setMemberInfo, setMemberToken
} from "../../member/actions";



function* loginUser({ payload: { user, history } }) {
    try {
        //* online mode
        const loginResponse = yield call(satelliteLogin, BACKEND_URL, { username:  user.username.toLowerCase(), password: user.password });
        // const token = loginResponse.key;
        const profileResponse = yield call(satelliteMemberProfile, BACKEND_URL, { token : loginResponse });

        localStorage.setItem("authUser", JSON.stringify(loginResponse));
        localStorage.setItem("userData", JSON.stringify(profileResponse));
        localStorage.setItem("permissions", JSON.stringify(profileResponse.permissions));
        yield put(setMemberToken(loginResponse.key));
        yield put(setPermissions(profileResponse.permissions));
        yield put(setMemberInfo(profileResponse));
        
        axios.defaults.headers.common['Authorization'] = "Token " + loginResponse.key

        yield put(loginSuccess(profileResponse));

        history.push('/dashboard'); 
 
    } catch (error) {
        yield put(apiError("Pati një gabim gjatë login-it."));
    }
}

function* logoutUser({ payload: { history } }) {
    try {
        // deregister previous token
        let a = localStorage.getItem("authUser")
        let authUser = JSON.parse(a)
        if (authUser) {
            const response = yield call(satelliteLogout, BACKEND_URL, authUser);
            yield put(logoutUserSuccess(response));
        }

        localStorage.clear();
        history.push('/login');
    } catch (error) {
        // yield put(apiError(error));
        localStorage.clear();
        history.push('/login');
    }
}

export function* watchUserLogin() {
    yield takeEvery(LOGIN_USER, loginUser)
}

export function* watchUserLogout() {
    yield takeEvery(LOGOUT_USER, logoutUser)
}

function* authSaga() {
    yield all([
        fork(watchUserLogin),
        fork(watchUserLogout),
    ]);
}

export default authSaga;